import { useState } from "react";
import { Award } from "lucide-react";
import { toast } from "sonner";
import { downloadAuthedFile } from "@/lib/api";

export function AcademyCertificateButton({ path, filename, testid = "academy-certificate-download" }) {
  const [downloading, setDownloading] = useState(false);
  const onClick = async () => {
    setDownloading(true);
    try {
      await downloadAuthedFile(path, filename);
      toast.success("Certificate downloaded");
    } catch (e) {
      toast.error(e.message || "Certificate download failed");
    } finally {
      setDownloading(false);
    }
  };
  return (
    <button
      data-testid={testid}
      disabled={downloading}
      onClick={onClick}
      className="font-mono text-[10px] tracking-[0.2em] uppercase border border-nc-green/60 text-nc-green hover:bg-nc-green/10 disabled:opacity-40 px-4 py-2.5 transition-colors shrink-0"
    >
      {downloading ? "Preparing…" : "Download Certificate"}
    </button>
  );
}

export function AcademyCertificateRow({ path, filename }) {
  return (
    <div data-testid="academy-certificate-row" className="px-5 py-4 flex items-center justify-between flex-wrap gap-3 bg-nc-green/5 border-t border-nc-green/20">
      <div className="flex items-center gap-2">
        <Award className="w-4 h-4 text-nc-green" strokeWidth={1.75} />
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-nc-green">Academy complete — certificate unlocked</p>
      </div>
      <AcademyCertificateButton path={path} filename={filename} />
    </div>
  );
}
